module.exports = __webpack_public_path__ + "6ca737afe5cef0c0a9c9bbfec4e398ff.woff2";